import React, { useEffect, useState, memo, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";

import { VenuePrefOptionList } from '../parts/VenuePrefOptionList';
import { PopoverText } from '../../common/parts/PopoverText';

import { orderState } from '../../../store/orderState';
import { courceItemState } from '../../../store/courceItemState';
import { courceVenueState } from '../../../store/courceVenueState';
import { selectedCourceVenueState } from '../../../store/selectedCourceVenueState';
import { companyState } from '../../../store/companyState';
import { isSurveyState } from '../../../store/isSurveyState';

export const FormVenue = memo((props) => {
  const { isConfirm } = props;
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [courceItemData, setCourceItemData] = useRecoilState(courceItemState);
  const [courceVenueData, setCourceVenueData] = useRecoilState(courceVenueState);
  const [selectedCourceVenue, setSelectedCourceVenue] = useRecoilState(selectedCourceVenueState);
  const cmData = useRecoilValue(companyState);
  const [isSurvayData, setIsSurvayData] = useRecoilState(isSurveyState);
  const initialSelectedCourceVenue = {
    id: '',
    clinic_id: null,
    name: null,
    prefecture_code: null,
    address: null,
  }

  const getVenues = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/venues`, data)
                .then(resp => {
                  console.log("get venues success");
                  console.log(resp.data);
                  setCourceVenueData(resp.data.cource_venues);
                })
                .catch(e => {
                  console.log("cource_venues error");
                  console.log(e.response);
                });
    return res;
  }

  const onChangePref = (e) => {
    setOrderData({
      ...orderData,
      requestpref_code: e.target.value,
      requestclinic_id: null,
      requestclinic: null,
      requestcource_clinic_id: '',
      options: [],
      requestdt1: null,
      requestdt1_ampm: '0',
      requestdt2: null,
      requestdt2_ampm: '0',
      requestdt3: null,
      requestdt3_ampm: '0',
      requestnote: '',
      examdt: null,
      examdtime: '',
      item_id: null,
    });
    setCourceItemData(null);
    setSelectedCourceVenue(initialSelectedCourceVenue);
    var data = { params: {
      prefecture_code: e.target.value,
      cource_id: orderData.cource_id
    }};
    getVenues(data);
  }

  const getCourceVenueItems = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/cource_venue_items`, data)
                .then(resp => {
                  console.log("get cource_venue_items success");
                  console.log(resp.data);
                  setIsSurvayData(resp.data.cource_venue);
                  setCourceItemData(resp.data.cource_venue_items);
                })
                .catch(e => {
                  console.log("cource_venue_items error");
                  console.log(e.response);
                });
    return res;
  }

  const onChangeVenue = (e) => {
    let cource_venue = courceVenueData.find(cource_venue => cource_venue.id === Number(e.target.value));
    setSelectedCourceVenue(cource_venue);
    setOrderData({
      ...orderData,
      requestcource_clinic_id: cource_venue.id,
      requestpref_code: cource_venue.prefecture_code,
      requestclinic_id: cource_venue.venue_id,
      requestclinic: cource_venue.name,
      options: [],
      requestdt1: null,
      requestdt1_ampm: '0',
      requestdt2: null,
      requestdt2_ampm: '0',
      requestdt3: null,
      requestdt3_ampm: '0',
      requestnote: '',
      examdt: null,
      examdtime: '',
      item_id: null,
    });
    var data = { params: {
      id: e.target.value,
      company_id: cmData.company_id,
    }};
    getCourceVenueItems(data);
  }

  return (
    <>
      <p className="h3">巡回会場の選択
        <PopoverText textTitle="巡回会場の選択" textBody="都道府県を選択し、会場を選択してください。" />
      </p>
      <div className="card mb-4">
        <div className="card-body">
          <div className="input-group mb-3">
            <label className="input-group-text" htmlFor="todofukenselect">都道府県</label>
            <select value={orderData.requestpref_code} className="form-select" aria-label="select" id="todofukenselect" onChange={onChangePref} disabled={isConfirm}>
              <VenuePrefOptionList />
            </select>
          </div>
          <hr />
          <div className="row gy-3">
            <div className="col-sm">
              { isConfirm ?
                <div className="select optional form_order_order_items_requesthospital list-group-item">
                  {orderData.requestclinic}
                </div>
              :
                <div className="select optional form_order_order_items_requesthospital">
                  <select value={orderData.requestcource_clinic_id} className="form-select" size="7" aria-label="size 3 select example"  onChange={onChangeVenue} disabled={isConfirm}>
                  <option value="" disabled>会場を選択は必須です。</option>
                  {courceVenueData?.map(item =>
                    <option key={item.id} value={item.id}>{item.name}</option>
                  )}
                  </select>
                </div>
              }
            </div>
            <div className="col-sm">
              <div className="card bg-light">
                <div className="card-header">会場情報</div>
                <div className="card-body">
                  会場名：{selectedCourceVenue.name}<br />
                  住所：{selectedCourceVenue.address}<br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-center h1"><i className="fas fa-chevron-down"></i></p>
    </>
  );
});
